//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Spinner from "../../../shared/Spinner";
export default {
    components: { Spinner: Spinner },
    props: {
        message: {
            type: String,
            required: true
        },
        confirmLabel: {
            type: String,
            default: 'Yes, confirmed'
        },
        confirmAction: {
            type: String,
            required: true
        },
        showLoader: {
            type: Boolean
        }
    },
    data: function data() {
        return {
            showCancel: false
        };
    },

    methods: {
        goBack: function goBack() {
            this.showCancel = false;
            Event.$emit('go-back');
        },
        confirm: function confirm() {
            this.showCancel = false;
            Event.$emit(this.confirmAction);
        }
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('cancel-notice', function () {
            _this.showCancel = true;
            Event.$emit('canceled');
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/reusable/ResidentSlideOutCancelBox.vue
// module id = sIjb
// module chunks = 0 1